import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=8c1b7aee&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=8c1b7aee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1b7aee",
  null
  
)

export default component.exports